import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    quote: 'Honest, fast, and professional. They fixed my truck right the first time.',
    name: 'Michael R.',
    role: 'F-250 Powerstroke Owner'
  }, {
    quote: 'Great service, fair pricing, and excellent communication.',
    name: 'David T.',
    role: 'F-350 Super Duty Owner'
  }, {
    quote: 'If you need Powerstroke repair, this is the team to trust.',
    name: 'James K.',
    role: '6.7L Diesel Owner'
  }];
  return <section id="testimonials" className="py-24 bg-slate-50" data-id="element-236" data-mp="2x1kzar0m4lw6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237" data-mp="2s1ynmm0fndph">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-238" data-mp="v9gavpibo6q7">
          <div className="inline-block px-4 py-1.5 bg-orange/10 border border-orange/20 rounded-full mb-6" data-id="element-239" data-mp="v8dite99jy8p">
            <span className="text-orange text-sm font-bold uppercase tracking-widest" data-id="element-240" data-mp="qbn3wu9738ov">
              Testimonials
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-display text-dark mb-4" data-id="element-241" data-mp="m51e408lhlc4">
            What Our Customers Say
          </h2>
          <div className="w-24 h-1 bg-orange mx-auto" data-id="element-242" data-mp="78k4pejyugs7"></div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-243" data-mp="c625ghntxpp4">
          {reviews.map((review, index) => <motion.div key={review.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative bg-white rounded-xl p-8 shadow-sm border border-slate-200 hover:shadow-xl hover:-translate-y-1 transition-all" data-id="element-244" data-mp="zxr0i5s1cs9r" data-mpi={index}>
              {/* Decorative Quote Icon */}
              <Quote className="absolute top-6 right-6 w-10 h-10 text-orange/10" data-id="element-245" data-mp="1sj5xhod0r751" />

              {/* Stars */}
              <div className="flex items-center mb-5" data-id="element-246" data-mp="1ogsz5l0lqbia">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-orange text-orange" data-id="element-247" data-mp="1jj0xhza5nb0w" data-mpi={i} />)}
              </div>

              {/* Quote */}
              <p className="text-lg text-dark leading-relaxed mb-6 font-medium" data-id="element-248" data-mp="1el7utg828z5d">
                "{review.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center pt-5 border-t border-slate-100" data-id="element-249" data-mp="14ud86aqwjxje">
                <div className="w-12 h-12 rounded-full bg-orange flex items-center justify-center text-white font-bold text-lg mr-4" data-id="element-250" data-mp="10s9s18tag4rs">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-251" data-mp="qt0te2nha1z3">
                  <div className="font-bold text-dark" data-id="element-252" data-mp="qulpvxtcruzl">{review.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-253" data-mp="32hff1c1ka0gy">{review.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Final CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-20 bg-dark rounded-2xl p-10 md:p-16 text-center relative overflow-hidden" data-id="element-254" data-mp="3cfd3o0nc1za3">
          {/* Accent stripe */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-orange" data-id="element-255" data-mp="2spjeluc05y9k"></div>

          <h3 className="text-3xl md:text-4xl font-display text-white mb-4" data-id="element-256" data-mp="2xi2vb05zl9il">
            Ready to Fix Your Truck{' '}
            <span className="text-orange" data-id="element-257" data-mp="20z5324rgoy12">the Right Way?</span>
          </h3>
          <p className="text-lg text-slate-400 mb-8 max-w-2xl mx-auto" data-id="element-258" data-mp="250qedlocl495">
            Contact us today for trusted diesel repair and expert service.
          </p>
          <a href="#appointment" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-md text-white bg-orange hover:bg-orange/90 transition-all shadow-lg shadow-orange/30 hover:shadow-orange/50 hover:-translate-y-0.5" data-id="element-259" data-mp="1lukcy33o3ifh">
            Get a Free Quote Today
          </a>
        </motion.div>
      </div>
    </section>;
}